import {ITimer} from "../../redux/modules/team/types";

export default class StartTimerResponse {
    public readonly href: string;
    public readonly timer: ITimer
    public readonly duration: number;
    public readonly name: string;
    public readonly start: string;

    constructor(json: any) {
        this.href = json.href;
        this.timer = json.timer as ITimer;
    }
}



// WEBPACK FOOTER //
// ./src/api/responses/StartTimerResponse.ts